var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsSubscription = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 4.375L4.375 4.375",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 6.875L4.375 6.875",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.375L4.375 9.375",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.125 1.25H3.875C2.77043 1.25 1.875 2.14543 1.875 3.25V11.1636C1.875 12.4226 3.12393 13.3004 4.30852 12.8739C4.75207 12.7143 5.2403 12.7331 5.6702 12.9266L6.67927 13.3807C7.20122 13.6155 7.79878 13.6155 8.32073 13.3807L9.3298 12.9266C9.7597 12.7331 10.2479 12.7143 10.6915 12.8739C11.8761 13.3004 13.125 12.4226 13.125 11.1636V3.25C13.125 2.14543 12.2296 1.25 11.125 1.25Z",
    stroke: "#868687",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsSubscription);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icons_subscription.1839afba027a501b49f32b43fd134b42.svg";